import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { MOTIVOS_PERDA_PADRAO, type MotivoPerda } from '../lib/motivosPerda';

// Lista de motivos de perda (#6419). Uma busca por sessão; falha não fica guardada.
let emCache: Promise<MotivoPerda[]> | null = null;

async function buscar(): Promise<MotivoPerda[]> {
    const { data, error } = await supabase
        .from('motivos_perda')
        .select('motivo, ordem, ativo, vai_para_remarketing, esperar_dias, roteiro')
        .order('ordem');
    if (error) throw error;
    if (!data || data.length === 0) throw new Error('motivos_perda vazia');
    return data as MotivoPerda[];
}

/**
 * Sempre devolve uma lista: enquanto carrega ou se a tabela não existir ainda, a
 * reserva com os motivos de sempre — a janela de perda nunca fica sem opção.
 */
export function useMotivosPerda() {
    const [motivos, setMotivos] = useState<MotivoPerda[]>(MOTIVOS_PERDA_PADRAO);
    const [doBanco, setDoBanco] = useState(false);

    useEffect(() => {
        let vivo = true;
        if (!emCache) emCache = buscar();
        emCache
            .then(lista => { if (vivo) { setMotivos(lista); setDoBanco(true); } })
            .catch(err => {
                console.warn('Falha ao carregar motivos_perda; usando a lista padrão', err);
                emCache = null;
            });
        return () => { vivo = false; };
    }, []);

    return { motivos, doBanco };
}
